<template>
  <a-modal
    title="新建"
    :width="380"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form">
        <a-form-item label="等级" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            style="width: 80%"
            placeholder="1"
            :precision="0"
            v-decorator="['level', {rules: [{required: true, message: '请输入'}]}]"
          />
        </a-form-item>
        <a-form-item label="价格" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            style="width: 80%"
            placeholder="0.00"
            :precision="2"
            :min="0"
            v-decorator="['price', {rules: [{required: true, message: '请输入'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
import pick from 'lodash.pick'
export default {
  name: 'GoodsVIPPriceCreate',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0
    }
  },
  mounted () {
    this.$nextTick(() => {
      console.log('mounted', this.model)
      if (this.model) {
        this.loadEditInfo(this.model)
      }
    })
  },
  methods: {
    loadEditInfo (data) {
      const { form } = this
      const formData = pick(data, ['level', 'price'])
      console.log('formData', formData)
      this.id = formData.id
      formData.price = (formData.price / 100).toFixed(2)
      form.setFieldsValue(formData)
      this.loading = false
    }
  }
}
</script>
